import classNames from 'classnames'
import { motion } from 'framer-motion'

import { COMMON_ICONS_TYPE, commonIcons } from '@apps-common/config/icons'
import { useMenuStore } from '@apps-common/stores/menuStore'
import { PiCaretLeftThin } from 'react-icons/pi'

// export const MenuButtonVariants: Variants = {
//   initial: {
//     width: '45px',
//     transition: {
//       ease: 'easeInOut',
//       when: 'afterChildren',
//       delay: 0.15,
//       duration: 0.2
//     }
//   },
//   enter: {
//     width: '200px',
//     bottom: '0px',
//     display: 'block',
//     transition: {
//       ease: 'easeInOut',
//       delay: 0.4,
//       duration: 0.2
//     }
//   },
//   exit: {
//     width: '45px',
//     transition: {
//       ease: 'easeInOut',
//       when: 'afterChildren',
//       delay: 0.15,
//       duration: 0.2
//     }
//   }
// }

// export const MenuButtonTextVariants: Variants = {
//   initial: {
//     opacity: 0,
//     left: 0,
//     transition: {
//       ease: 'easeInOut',
//       duration: 0.2
//     }
//   },
//   enter: {
//     opacity: 1,
//     left: 0,
//     display: 'block',
//     transition: {
//       ease: 'easeInOut',
//       delay: 0.5,
//       duration: 0.2
//     }
//   },
//   exit: {
//     opacity: 0,
//     left: 10,
//     transitionEnd: {
//       display: 'none'
//     },
//     transition: {
//       ease: 'easeInOut',
//       duration: 0.2
//     }
//   }
// }

interface IProps {
  id: string
  label: string
  description: string
  icon: COMMON_ICONS_TYPE
  iconClasses?: string
  isPathMatch: boolean
  callback: () => void
}

export const MenuButton: React.FC<IProps> = ({ id, label, description, icon, iconClasses, isPathMatch, callback }) => {
  const { open, setOpen } = useMenuStore()
  const Icon = commonIcons[icon]
  // const controls = useAnimationControls()

  // useEffect(() => {
  //   if (open) {
  //     controls.start('enter')
  //   } else {
  //     controls.start('exit')
  //   }
  // }, [controls, open])

  return (
    <button
      type='button'
      onClick={() => {
        if (callback) {
          callback()
        }
        setOpen(false)
      }}
      className='w-full'
    >
      <motion.div
        key={id}
        className={classNames(
          'relative flex items-center justify-left gap-[10px] text-text/70 overflow-visible pl-2 pr-3 py-3 bg-surface w-full rounded-[26px]',
          'shadow-[0_18px_45px_rgba(15,23,42,0.10),0_4px_12px_rgba(15,23,42,0.06)]'
        )}
      >
        <div className='relative z-[1] flex items-center justify-start gap-4 w-full h-[45px]'>
          <div className='ml-[7px] bg-gradient-to-br from-mm-brand to-mm-brand-2 text-on-mm-brand rounded-full p-[11px]'>
            <Icon className={classNames('w-[22px] min-w-[22px] h-[22px] min-h-[22px] opacity-/70', iconClasses)} />
          </div>
          <div className='text-left grow'>
            <div className={classNames('text-[0.9rem] jost')}>{label}</div>
            <div className={classNames('text-[0.8rem] jost-light opacity-60')}>{description}</div>
          </div>
          <div>
            <PiCaretLeftThin className='text-[1.4rem] rotate-180' />
          </div>
        </div>
      </motion.div>
    </button>
  )
}
